import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Collapse } from 'react-collapse';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const Roadmap = styled.section`
  padding: 4rem 2rem;
  background: #f4f4f4;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Raleway', sans-serif;
  color: #333;
  animation: ${fadeIn} 2s ease-in-out;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  font-family: 'Raleway', sans-serif;
  color: #555;
  animation: ${fadeIn} 2s ease-in-out;
`;

const RoadmapList = styled.ul`
  list-style-type: none;
  padding: 0;
  animation: ${fadeIn} 2s ease-in-out;
`;

const RoadmapItem = styled.li`
  font-size: 1.2rem;
  margin: 1.5rem 0;
  font-family: 'Raleway', sans-serif;
  background: #fff;
  padding: 1rem 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, background 0.3s;
  cursor: pointer;

  &:hover {
    background: #0093e9;
    color: #fff;
    transform: scale(1.05);
    animation: ${bounce} 1s;
  }
`;

const AccordionContent = styled.div`
  padding: 1rem 2rem;
  text-align: left;
  font-family: 'Raleway', sans-serif;
  font-size: 1rem;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const RoadmapSection = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index]
    }));
  };

  const roadmapData = [
    {
      quarter: "Q1 2024",
      title: "Official Launch on pump.fun",
      details: [
        "The ADT token will be launched on pump.fun, enabling early supporters to participate in the project and acquire tokens at the ground level.",
        "Initial Community Building: Focus on building a strong community through social media campaigns, AMAs (Ask Me Anything sessions), and partnerships with influencers in the blockchain and advertising industries.",
        "Website and Whitepaper Release: Launch the official AdChain website and release the whitepaper to provide comprehensive information about the project’s goals, technology, and roadmap.",
        "Strategic Partnerships: Begin forming strategic partnerships with key players in the advertising and blockchain sectors to strengthen the ecosystem."
      ]
    },
    {
      quarter: "Q2 2024",
      title: "Development Phase",
      details: [
        "Finalize the conceptualization of the AdChain platform and begin the development phase.",
        "Developing the core smart contracts for ad placements and payments.",
        "Designing the user interface for the AdChain DApp.",
        "Integrating Solana blockchain functionalities.",
        "Conduct alpha testing with a select group of users to identify and fix bugs, gather feedback, and improve the platform’s usability.",
        "Continue to engage with the community through regular updates, feedback sessions, and incentivized activities to keep the community involved in the development process."
      ]
    },
    {
      quarter: "Q3 2024",
      title: "Beta Launch",
      details: [
        "Launch the beta version of the AdChain platform to a wider audience.",
        "Opening the platform for advertisers and publishers to start using the service.",
        "Implementing decentralized reviews and smart contract functionalities.",
        "Providing ADT token rewards for early adopters and active participants.",
        "Collect feedback from beta users to make necessary improvements and iterations on the platform.",
        "Launch targeted marketing campaigns to increase awareness and drive user acquisition.",
        "Expand partnerships with more advertising agencies, blockchain projects, and tech companies to broaden the reach and capabilities of AdChain."
      ]
    },
    {
      quarter: "Q4 2024",
      title: "Full Platform Launch",
      details: [
        "Officially launch the full version of the AdChain platform, making it accessible to the broader market.",
        "Ensuring full functionality of all platform features, including ad placements, payments, reviews, and rewards.",
        "Enhancing security measures and scalability to handle increased user activity.",
        "Integrate AdChain with other major advertising and blockchain platforms to create a seamless experience for users.",
        "Provide comprehensive user education and support through tutorials, webinars, and customer service to ensure a smooth onboarding experience for new users.",
        "Continue to incentivize community engagement through ADT token rewards, contests, and exclusive events."
      ]
    },
    {
      quarter: "Q1 2025",
      title: "Mobile App Launch and Global Expansion",
      details: [
        "Develop and launch the AdChain mobile app for iOS and Android to enhance accessibility and user experience.",
        "Expand the platform’s reach to key international markets, focusing on regions with high demand for digital advertising and blockchain adoption.",
        "Begin developing advanced features such as AI-driven ad targeting, real-time analytics, and more sophisticated campaign management tools.",
        "Maintain a cycle of continuous improvement based on user feedback and market trends to keep AdChain at the forefront of the digital advertising industry."
      ]
    }
  ];

  return (
    <Roadmap id="roadmap">
      <Title>Our Roadmap</Title>
      <Subtitle>Check out our roadmap to see our journey and upcoming milestones.</Subtitle>
      <RoadmapList>
        {roadmapData.map((item, index) => (
          <div key={index}>
            <RoadmapItem onClick={() => toggleItem(index)}>
              {item.quarter}: {item.title}
            </RoadmapItem>
            <Collapse isOpened={!!openItems[index]}>
              <AccordionContent>
                <ul>
                  {item.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </AccordionContent>
            </Collapse>
          </div>
        ))}
      </RoadmapList>
    </Roadmap>
  );
};

export default RoadmapSection;
